import type { WrapperFC } from '@george-labs.com/design-system';
import { StripeTitle } from '@george-labs.com/design-system';
import type { ReactNode } from 'react';

interface Props {
    'data-cy': string;
    overline?: string;
    children: ReactNode;
}

export const FocusPageStripeCenter: WrapperFC<Props> = ({
    'data-cy': dataCy,
    overline,
    children,
}) => {
    if (typeof children === 'string') {
        return (
            <StripeTitle
                data-cy={dataCy}
                id="focusPageTitle"
                overline={overline && <span data-cy={`${dataCy}-overline`}>{overline}</span>}
            >
                {children}
            </StripeTitle>
        );
    }

    return (
        <div data-cy={dataCy} id="focusPageTitle">
            {children}
        </div>
    );
};

FocusPageStripeCenter.wrapsComponent = StripeTitle;
